export enum HolidayTypes {
  Cart = 'ddd00396-8737-452c-9968-99c85ea08ddd',
  Profile = 'ddd01396-8737-452c-9968-99c85ea08ddd',
  Banner = 'ddd02396-8737-452c-9968-99c85ea08ddd',
}
